module.exports = __webpack_public_path__ + "assets/optimize.703ad956.svg";